
export function decodeJWTExpiration(token: string): string | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    const payload = parts[1];
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const payloadObj = JSON.parse(decodedPayload);

    // JWT expiration is in 'exp' field (Unix timestamp in seconds)
    if (payloadObj.exp) {
      return new Date(payloadObj.exp * 1000).toISOString();
    }

    console.warn('JWT token does not contain expiration field');
    return null;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
}

/**
 * Extract user info from JWT token if available
 * @param token - JWT token string
 * @returns Object with email and name, or null if invalid
 */
export function decodeJWTUserInfo(
  token: string,
): { email: string; name: string } | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const payload = parts[1];
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const payloadObj = JSON.parse(decodedPayload);

    // Common JWT fields for user info
    const email =
      payloadObj.email ||
      payloadObj.preferred_username ||
      payloadObj.upn ||
      '';
    const name = payloadObj.name || payloadObj.given_name || email || '';

    return { email, name };
  } catch (error) {
    console.error('Error extracting user info from JWT:', error);
    return null;
  }
}
